import ActuarialReport from '../../../reports/claimsnew/ActuarialReport';

const InsuranceRatioChart = () => <ActuarialReport />;

export default InsuranceRatioChart;
